<div class="title">
  {{text}}
  <span class="spacer"></span>
  <ng-content></ng-content>
</div>
